(function() {
  // List of selectors to search for replacements
  const selectors = [
    'body',
    '.img-banner-2__tag',
    '.testimonial-box__name',
    '.xo-product-info-content__title',
    '.xo-contact__heading',
    '.img-with-text-8__content',
    '.xo-text__heading',
    '.xo-text__char',
    '.introduction-text__text-scroll',
    '.img-with-text-2__sub-heading',
    '.product-card-custom__header',
    '.xo-product-card__title',
    '.testimonial-box__content',
    '.xo-product-info-content__vendor',
    '.img-with-text-8__sub-heading',
    '.featured-product-2__product-description'
  ];

  // All text replacement patterns
  const textReplacements = [
    { pattern: /Boost\+/g, replacement: 'Boost<span class="xo-plus-highlight">+</span>' },
    { pattern: /boost\+/g, replacement: 'boost<span class="xo-plus-highlight">+</span>' },
    { pattern: /Recharge\+/g, replacement: 'Recharge<span class="xo-plus-highlight">+</span>' },
    { pattern: /recharge\+/g, replacement: 'recharge<span class="xo-plus-highlight">+</span>' },
    { pattern: /RECHARGE\+/g, replacement: 'RECHARGE<span class="xo-plus-highlight">+</span>' },
    { pattern: /BOOST\+/g, replacement: 'BOOST<span class="xo-plus-highlight">+</span>' },
    { pattern: /BOOSTER\+/g, replacement: 'BOOSTER<span class="xo-plus-highlight">+</span>' },
    { pattern: /EAA\+/g, replacement: 'EAA<span class="xo-plus-highlight">+</span>' },
    { pattern: /Eaa\+/g, replacement: 'Eaa<span class="xo-plus-highlight">+</span>' },
    { pattern: /Yesterday\+/g, replacement: 'Yesterday<span class="xo-plus-highlight">+</span>' },
    { pattern: /SUPPORTCH/g, replacement: 'SUPPORT<span class="xo-plus-highlight">CH</span>' },
    { pattern: /\+/g, replacement: '<span class="xo-plus-highlight">+</span>', onlyFor: ['.xo-text__char'] }
  ];

  function highlightPlusSigns() {
    // Loop through each selector
    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      
      elements.forEach(el => {
        // Skip script and style tags
        if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE') return;
        
        // Skip if already processed to avoid double-processing
        if (el.dataset.highlightProcessed === 'true') return;
        
        // Filter replacements for this selector
        const applicableReplacements = textReplacements.filter(rule => {
          return !rule.onlyFor || rule.onlyFor.includes(selector);
        });
        
        // Check each child text node
        Array.from(el.childNodes).forEach(node => {
          if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent;
            
            // Check if text contains any pattern that needs replacement
            if (applicableReplacements.some(r => r.pattern.test(text))) {
              const span = document.createElement('span');
              let newHTML = text;
              
              applicableReplacements.forEach(rule => {
                // Only replace if the replacement doesn't already exist (avoid double-wrapping)
                if (!newHTML.includes(rule.replacement)) {
                  newHTML = newHTML.replace(rule.pattern, rule.replacement);
                }
              });
              
              // Only replace if content actually changed
              if (newHTML !== text) {
                span.innerHTML = newHTML;
                node.parentNode.replaceChild(span, node);
              }
            }
          }
        });
        
        // Also check innerHTML for patterns we might have missed
        if (el.innerHTML && el.querySelector('script') === null) {
          let newHTML = el.innerHTML;
          let changed = false;
          
          applicableReplacements.forEach(rule => {
            // Only replace if the replacement doesn't already exist (avoid double-wrapping)
            if (!newHTML.includes(rule.replacement)) {
              const oldHTML = newHTML;
              newHTML = newHTML.replace(rule.pattern, rule.replacement);
              if (newHTML !== oldHTML) changed = true;
            }
          });
          
          if (changed) {
            el.innerHTML = newHTML;
          }
        }
        
        // Also handle aria-label attribute
        if (el.hasAttribute('aria-label')) {
          let ariaLabel = el.getAttribute('aria-label');
          let changed = false;
          
          applicableReplacements.forEach(rule => {
            // Only replace if the replacement doesn't already exist (avoid double-wrapping)
            if (!ariaLabel.includes(rule.replacement)) {
              const oldLabel = ariaLabel;
              ariaLabel = ariaLabel.replace(rule.pattern, rule.replacement);
              if (ariaLabel !== oldLabel) changed = true;
            }
          });
          
          if (changed) {
            el.setAttribute('aria-label', ariaLabel);
          }
        }
        
        // Mark as processed
        el.dataset.highlightProcessed = 'true';
      });
    });
  }

  // Run on page load
  function runHighlighting() {
    // Run highlighting with a small delay to ensure DOM is fully ready
    setTimeout(highlightPlusSigns, 100);
  }

  // Debounce function to prevent excessive highlighting
  let highlightTimeout;
  function debouncedHighlight() {
    clearTimeout(highlightTimeout);
    highlightTimeout = setTimeout(highlightPlusSigns, 500);
  }

  // Wait until HTML is fully parsed
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runHighlighting);
  } else if (document.readyState === 'interactive') {
    runHighlighting();
  } else {
    // Already complete or interactive
    runHighlighting();
  }

  // Re-run on dynamic content updates (for SPA/Turbo)
  document.addEventListener('turbo:load', runHighlighting);
  
  // Listen to specific events that indicate new content was added
  document.addEventListener('shopify:section:load', debouncedHighlight);
  document.addEventListener('shopify:section:reorder', debouncedHighlight);

  // IntersectionObserver for elements that become visible
  const intersectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Element became visible, check if it needs highlighting
        if (entry.target.dataset.highlightProcessed !== 'true') {
          debouncedHighlight();
        }
      }
    });
  }, { threshold: 0 });

  // Re-run periodically to catch any dynamically added content
  setInterval(() => {
    // Look for elements that haven't been processed yet
    const unprocessedElements = document.querySelectorAll(selectors.map(s => s + ':not([data-highlight-processed="true"])').join(', '));
    if (unprocessedElements.length > 0) {
      debouncedHighlight();
    }
  }, 2000);
})();